module.exports = __webpack_public_path__ + "img/icon-1.32a5519b.png";